import { render, staticRenderFns } from "./AvisoAsientoOcupado.vue?vue&type=template&id=3312d02d"
import script from "./AvisoAsientoOcupado.vue?vue&type=script&lang=js"
export * from "./AvisoAsientoOcupado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports